document.addEventListener("DOMContentLoaded", function () {
    document
        .querySelectorAll("form.search, form.search-modal__form")
        .forEach((form) => {
            form.addEventListener("submit", function (event) {
                const input = form.querySelector('input[type="search"]');
                if (input && input.value.trim() !== "") {
                    const trimmedValue = input.value.trim();
                    if (
                        !(
                            trimmedValue.startsWith('"') &&
                            trimmedValue.endsWith('"')
                        )
                    ) {
                        input.value = `"${trimmedValue}"`;
                    }
                }
            });
        });
});
